"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStoreCode = exports.getLiveStoreCode = exports.getEnvironment = exports.getCountryList = void 0;

require("regenerator-runtime/runtime");

var _ = require("./");

var _countries = _interopRequireDefault(require("../countries"));

var _index = _interopRequireWildcard(require("./index"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getStoreCode = function getStoreCode() {
  var loc = window.location.host;
  if (loc.includes('0.0.0.0') || loc.includes('localhost') || !window.theme) return _.StoreCode.XD;
  return window.theme.gsCode;
}; // TODO: Move to types package when enums correctly build


exports.getStoreCode = getStoreCode;
var Environment;

(function (Environment) {
  Environment["PRODUCTION"] = "production";
  Environment["STAGING"] = "staging";
  Environment["DEVELOPMENT"] = "development";
})(Environment || (Environment = {}));

var getEnvironment = function getEnvironment(store) {
  var storeCode = store || getStoreCode();
  if (storeCode === 'xd') return Environment.DEVELOPMENT;
  if (Object.keys(_index.STAGING_STORES).includes(storeCode)) return Environment.STAGING;
  return Environment.PRODUCTION;
};

exports.getEnvironment = getEnvironment;

var getCountryList = function getCountryList() {
  return _countries["default"].sort(function (x, y) {
    var a = x.name.toLowerCase();
    var b = y.name.toLowerCase(); // eslint-disable-next-line no-nested-ternary

    return a < b ? -1 : a > b ? 1 : 0;
  });
};

exports.getCountryList = getCountryList;

var getLiveStoreCode = function getLiveStoreCode() {
  var storeCode = getStoreCode();

  var stores = _objectSpread(_objectSpread({}, _index["default"]), _index.STAGING_STORES);

  return stores[storeCode].liveStoreCode ? stores[storeCode].liveStoreCode : stores[storeCode].storeCode;
};

exports.getLiveStoreCode = getLiveStoreCode;